import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root'
})
export class UserPreferenceService {

  constructor(private http: HttpClient) { }

  get(): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions$ = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token, 
        'language-iso': 'en'
      })
    };

    return this.http.get(ApiEndPoint.Users.preference, httpOptions$);
  }

  update($request) {
    const token = localStorage.getItem('token');

    const httpOptions$ = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token, 
        'language-iso': 'en'
      })
    };

    return this.http.put(ApiEndPoint.Users.preference, $request, httpOptions$);
  }
}
